// Port of the sidebar models in webapp/src/store/sidebar.ts

export type CategoryType = 'system' | 'custom'

export interface Category {
    id: string
    name: string
    userID: string
    teamID: string
    createAt: number
    updateAt: number
    deleteAt: number
    collapsed: boolean
    sortOrder: number
    type: CategoryType
    isNew: boolean
}

export interface CategoryBoardMetadata {
    boardID: string
    hidden: boolean
}

export interface CategoryBoards extends Category {
    boardMetadata: CategoryBoardMetadata[]
}

export const DefaultCategory: CategoryBoards = {
    id: '',
    name: '看板',
} as CategoryBoards
